<!--
 * @Author: andy_chen
 * @created: 2018-10-23 15:57:46
 * 我想去的
-->

<template>
    <div class="container">
        <div v-if="!isBlank">
            <div
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="disableCheckScroll"
                infinite-scroll-immediate-check="false"
                infinite-scroll-distance="50"
            >
                <div class="topic-list">
                    <topic-item
                        v-for="(topic,index) in list"
                        :topic="topic"
                        :key="topic.topicId"
                        @unLikeTopicSuccess="unlikeTopicSuccess(index)"
                    ></topic-item>
                </div>
            </div>
            <p v-show="loading" class="page-infinite-loading">
                <span class="page-infinite-text">加载中</span>
                <spinner size="0.8rem" type="triple-bounce"></spinner>
            </p>
            <p v-show="isEnd" class="page-infinite-nomore">
                <span>没有更多了</span>
            </p>
        </div>
        <blank class="blank-box" v-if="isBlank" text="暂无想去的地方~"></blank>
    </div>
</template>

<script>
import TopicItem from "../components/TopicList/TopicItem";
import Blank from "../components/Blank/index";
import Spinner from "@/components/Spinner/index";
import { getMyLikeList, getOtherLikeList } from "../api/user";

export default {
    name: "MyFavor",
    components: {
        TopicItem,
        Blank,
        Spinner
    },
    data() {
        return {
            list: [],
            isEnd: false,
            currentPage: 1,
            pageSize: 30,
            loading: false
        };
    },

    computed: {
        disableCheckScroll() {
            return this.loading || this.isEnd;
        },
        isBlank() {
            return this.isEnd && this.list.length === 0;
        }
    },

    mounted() {
        this.isSelf =
            this.$route.params.id === this.$store.getters.userInfo.userId;
        this.loadMore();
    },

    methods: {
        loadMore() {
            this.loading = true;
            this.appendList().then(() => {
                this.loading = false;
            });
        },

        appendList() {
            let params = {
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };

            let getLikeList = getMyLikeList;
            if (!this.isSelf) {
                params.targetId = this.$route.params.id;
                getLikeList = getOtherLikeList;
            }

            return getLikeList(params).then(res => {
                if (+res.code === 200) {
                    this.list = [...this.list, ...res.data];
                    this.currentPage = this.currentPage + 1;
                    this.isEnd = res.data.length < this.pageSize; //当返回的数据小于请求的数量，说明已经没有更多数据了
                } else {
                    this.$toast.open({ msg: res.msg });
                }
            });
        },

        unlikeTopicSuccess(index) {
            // 我想去的才从列表移除，如果是TA想去的，则不做任何处理
            if (this.isSelf) {
                this.list.splice(index, 1);
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

.container {
    background: $baseBackgroundColor;
    padding: 0.3rem 0;
}

.page-infinite-loading {
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.page-infinite-text {
    padding-right: 0.1rem;
    color: $secondaryColor;
}

.page-infinite-nomore {
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    color: $secondaryColor;
}

.topic-list {
    padding-bottom: 0;
}

.blank-box {
    padding-top: 3.22rem;
}

.blank-btn {
    margin-top: 0.2rem;
    width: 2.8rem;
}
</style>
